const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

function getToken() {
    const raw = localStorage.getItem("token") || "";
    return raw.startsWith("Bearer ") ? raw.slice(7) : raw;
}

export const deleteChatMessageApi = async (leadId, role, messageId) => {
    const token = getToken();

    const response = await fetch(
        `${API_BASE_URL}/${role}/lead/leads/${leadId}/chat/messages/${messageId}`,
        {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        }
    );

    if (!response.ok) {
        let errorData = null;
        try {
            errorData = await response.json();
        } catch (_) {
            errorData = null;
        }

        throw {
            ...(errorData || {}),
            statusCode: response.status,
            message: errorData?.message || `Delete failed with status ${response.status}`,
        };
    }
};

